import { isAnyOf, PayloadAction } from "@reduxjs/toolkit";
import { useEffect } from 'react';

import { startAppListening } from "../../listener";
import { resourceActions } from "../resources/slice";
import { NewResource, Resource } from "../resources/types";
import { themeActions } from '../themes/slice';
import { NewTheme, Theme } from '../themes/types';

import { rendererActions } from "./slice";
import { useAsyncRender } from './hooks';
import { saveResource } from '../resources/actions';

export const useAutoExpireCache = () => {

  const render = useAsyncRender();

  useEffect(
    () => {
      const stoppers = [
        startAppListening({
          matcher: isAnyOf(
            resourceActions.deleteResource,
            saveResource
          ),
          effect: (action: PayloadAction<NewResource | Resource | string>, api) => {


            const resources = api.getState().resources;

            const resourceToRender = typeof (action.payload) === 'string' ?
            resources[action.payload] : action.payload;

            if (resourceToRender.id) {
              render(resourceToRender as Resource, true).then(
                rendered => {
                  api.dispatch(rendererActions.invalidateResourceByID(resourceToRender.id!));
                  if (rendered) {
                    api.dispatch(rendererActions.cacheRenderedResource(rendered));
                  }
                }
              );
            }

          }
        }),
        startAppListening({
          matcher: isAnyOf(
            themeActions.deleteTheme,
            themeActions.saveTheme
          ),
          effect: (action: PayloadAction<NewTheme | Theme | string>, api) => {
            const themeID = typeof (action.payload) === 'string' ? action.payload : action.payload.id;
            if (themeID) {
              api.dispatch(rendererActions.invalidateTheme(themeID));
            }
          }
        }),
      ];

      return () => {
        for (const stopper of stoppers) {
          stopper();
        }
      };
    },
    [render]
  );
};
